import dayjs from "dayjs"; 
export const DISPLAY_DATE_FORMAT = "DD-MM-YYYY"; 
const ISO_DATE = /^\d{4}[-/]\d{2}[-/]\d{2}([T ].*)?$/;
const DATE_KEY = /date/i;

const looksLikeDate = (key: string, value: unknown): boolean => {
  if (value instanceof Date) return true;
  if (typeof value === "string" && ISO_DATE.test(value)) return true;
  if (DATE_KEY.test(key)) {
    if (typeof value === "number") return true;
    if (typeof value === "string" && /\D/.test(value) && value.length >= 8) return true;
  }
  return false;
};

export const toSearchText = (value: unknown, key = ""): string => { 
  if (value === null || value === undefined) return "";
  if (looksLikeDate(key, value)) {
    const d = dayjs(value as any);
    if (d.isValid()) return d.format(DISPLAY_DATE_FORMAT);
  }
  return String(value);
};
export const filterByColumnSearch = <T extends Record<string, any>>(
  rows: T[],
  columnSearch: Record<string, string>,
  getters: Record<string, (row: T) => string> = {},
): T[] => {
  const active = Object.entries(columnSearch).filter(([, v]) => v?.trim());
  if (!active.length) return rows;

  const result = rows.filter((row) =>
    active.every(([key, term]) => {
      const text = getters[key] ? getters[key](row) : toSearchText(row[key], key);
      return text.toLowerCase().includes(term.trim().toLowerCase());
    }),
  ); 
  return result;
};